var _rect, _rect2, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 34,
    viewBox: "0 0 50 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.17212,
    y: 0.5,
    width: 47.6721,
    height: 33,
    rx: 4.5,
    stroke: "#E5E9EC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.67212,
    y: 1,
    width: 46.6721,
    height: 32,
    rx: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3416 23.8762C23.7526 25.2473 21.6915 26.075 19.4393 26.075C14.4138 26.075 10.3398 21.9542 10.3398 16.871C10.3398 11.7878 14.4138 7.66699 19.4393 7.66699C21.6915 7.66699 23.7526 8.49466 25.3416 9.8657C26.9305 8.49466 28.9916 7.66699 31.2439 7.66699C36.2694 7.66699 40.3433 11.7878 40.3433 16.871C40.3433 21.9542 36.2694 26.075 31.2439 26.075C28.9916 26.075 26.9305 25.2473 25.3416 23.8762Z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3416 23.8762C27.298 22.1881 28.5386 19.6761 28.5386 16.871C28.5386 14.0659 27.298 11.5539 25.3416 9.8657C26.9305 8.49466 28.9916 7.66699 31.2439 7.66699C36.2693 7.66699 40.3433 11.7878 40.3433 16.871C40.3433 21.9542 36.2693 26.075 31.2439 26.075C28.9916 26.075 26.9305 25.2473 25.3416 23.8762Z",
    fill: "#F9A000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.3416 9.86621C27.2981 11.5544 28.5386 14.0664 28.5386 16.8715C28.5386 19.6765 27.2981 22.1885 25.3416 23.8767C23.3851 22.1885 22.1445 19.6765 22.1445 16.8714C22.1445 14.0664 23.3851 11.5544 25.3416 9.86621Z",
    fill: "#FF5E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/Mastercard.f2b486fe8ff34ff4f642da56f8578eaf.svg";
export { ForwardRef as ReactComponent };